<div id="_star-sys-display_component-wrapper_" class="w-full flex flex-col">
  <!-- STAR-SYSTEMS -->
  <div class="p-2 w-full flex flex-wrap iBTTiny:flex-col lanPixel2xl:flex-row">
    <div id="_SYSTEM-HEX" class="text-white w-full flex flex-row flex-wrap items-stretch iBTTiny:flex-col lanPixel2xl:flex-row">
      <!-- STARLESS-NEXUS -->
      @if (starSystem()?.type === "Starless Nexus") {
        <div id="_Starless-Nexus" class="text-white flex border-1">Starless Nexus</div>
      }
      <!-- STAR-SYSTEMS -->
      @for (star of starSystem()?.stars; track star) {
        <div id="_STAR-SYSTEM" class="text-white border flex box-border flex-expand">
          <!-- STAR -->
          <div id="_STAR" class="p-2 flex-none">
            <starfire-image class="starImage tooltip-tr" [attr.data-tooltip]="star.type + ' (' + star.strategicHex + ')'" [folder]="'stars'" [name]="star.type"></starfire-image>
            <div class="text-1.25 font-bold ism-gold">Star: {{ star.type }}</div>
          </div>

          <!-- PLANETS & MOONS -->
          <div id="_PLANTS & MOONS" class="flex flex-col">
            @for (planet of star.planets; track $index) {
              <div class="border-b border-b-gray-700 flex">
                <div id="_PLANET" class="flex flex-grow flex-expand justify-start">
                  <div class="w-24 h-24 flex items-center justify-center">
                    <starfire-image class="tooltip-tr" [ngClass]="{ planetImage: planet.type != 'I', planetImageSmall: planet.type === 'I' }" [folder]="'planets'" [name]="planet.image || planet.type" [attr.data-tooltip]="planet.type + ' (' + planet.strategicHex + ')'"></starfire-image>
                  </div>
                  <div id="_Planet-Info" class="mx-2 flex-col items-center justify-start whitespace-nowrap">
                    <div class="planetInfo">Type: {{ planet.type }}</div>
                    @if (planet.multiplier > 0) {
                      <div class="planetInfo">Eco: {{ planet.multiplier }} * {{ planet.rei }}</div>
                    }
                    @if (populations(); as pps) {
                      @if (pps[planet._id]; as ops) {
                        @for (op of ops | keyObject; track $index) {
                          <div class="planetInfo">Race: {{ raceLookup.get(op.key)?.name }}</div>
                          <div class="planetInfo">PU: {{ op.value.pu }} / IU: {{ op.value.iu }}</div>
                        }
                      }
                    }
                  </div>
                </div>

                @if (displayMoons() && planet.moons.length > 0) {
                  <div id="_MOONS" class="ml-2 text-yellow-300 border-0 border-yellow-400 flex flex-none flex-col">
                    <!-- put moons here -->
                    @for (moon of planet.moons; track $index) {
                      <div class="p-2 flex flex-none items-center whitespace-nowrap">
                        <starfire-image class="moonImage tooltip-tr" [attr.data-tooltip]="moon.type + ', Orbit: ' + moon.distance + ', Radian: ' + moon.radian" [folder]="'moons'" [name]="moon.image || moon.type"> </starfire-image>
                        <div id="moonInfo" class="px-2 inline-flex flex-col items-start">
                          <div class="moonInfo">Eco: {{ moon.multiplier }} * {{ moon.rei }}</div>
                          @if (populations(); as opsh) {
                            @if (opsh[moon._id]; as ops) {
                              @for (op of ops | keyObject; track $index) {
                                <div class="moonInfo">Race: {{ raceLookup.get(op.key)?.name }}</div>
                                <div class="moonInfo">PU: {{ op.value.pu }} / IU: {{ op.value.iu }}</div>
                              }
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div id="_wp-Table" class="px-2 py-4 flex flex-1 flex-col">
    <div class="text-1.25 font-bold ism-gold">Warp Points</div>
    <table class="mx-2 w-full">
      <tr class="data">
        <th class="text-center w-1/7 ism-gold">Destination</th>
        <th class="text-center w-1/7 ism-gold">Location</th>
        <th class="text-center w-1/7 ism-gold">Distance</th>
        <th class="text-center w-1/7 ism-gold">Radian</th>
        <th class="text-center w-1/7 ism-gold">Open</th>
        <th class="text-center w-1/7 ism-gold">Type</th>
        <th class="text-center w-1/7 ism-gold">Capacity</th>
      </tr>
      @for (warpPoint of starSystem()?.warpPoints; track $index) {
        <tr class="data">
          <td id="_Destination" class="text-center data tooltip-t" [attr.data-tooltip]="'Destination / To Explore'">
            @if (warpPoint?.destinationStarSystem) {
              <a (click)="openStarSystem(starSystem()?.campaignId, warpPoint?.destinationStarSystem)">
                {{ warpPoint.destination }}
              </a>
            } @else {
              unexplored
            }
          </td>
          <td class="text-center tooltip-tr" [attr.data-tooltip]="'Location'">{{ warpPoint.strategicHex }}</td>
          <td class="text-center tooltip-tr" [attr.data-tooltip]="'Distance'">{{ warpPoint.distance }}</td>
          <td class="text-center tooltip-tr" [attr.data-tooltip]="'Radian'">{{ warpPoint.radian }}</td>
          <td class="text-center tooltip-tr" [attr.data-tooltip]="'Open'">{{ (warpPoint?.open || 0) === 1 ? "Open" : "Closed" }}</td>
          <td class="text-center tooltip-tl" [attr.data-tooltip]="'Type'">{{ warpPoint.type }}</td>
          <td class="text-center tooltip-tr" [attr.data-tooltip]="'Capacity'">{{ warpPoint.capacity }}</td>
        </tr>
      }
    </table>
  </div>
</div>
